import { GalleryAssignmentContextProvider, GalleryDealContextProvider, GalleryProductContextProvider, GalleryVisualTypeContextProvider } from 'components/pages/Gallery/_main/contexts'

import { ClientGalleryContextProvider } from 'components/pages/Gallery/_main/ClientGallery/_main'
import { AnalyticsEvent } from 'utils/analytics'
import { ClientPropertyDocumentsGallery } from '../../ClientPropertyDocumentsGallery'
import { FC } from 'react'
import { ThreadContextProvider } from 'components/common/Threads/context'
import { ClientPropertyEmptyDocumentsGalleryComponent } from '../../ClientPropertyEmptyDocumentsGallery'
import { useClientProperty } from '../contexts'

export const ClientPropertyDocumentsPage: FC = () => {
  const { assignmentId, propertyId, handleClickOnEmptyAction } = useClientProperty()

  if (!assignmentId) return (
    <ClientPropertyEmptyDocumentsGalleryComponent
      propertyId={propertyId}
      beforeClickEvent={() => {
        handleClickOnEmptyAction(AnalyticsEvent.PROPERTY_ORDER_VISUALS_CLICKED)
      }}
    />
  )

  return (
    <GalleryAssignmentContextProvider assignmentId={assignmentId}>
      <GalleryDealContextProvider assignmentId={assignmentId} keepPreviousData={true}>
        <GalleryVisualTypeContextProvider assignmentId={assignmentId}>
          <GalleryProductContextProvider assignmentId={assignmentId}>
            <ThreadContextProvider assignmentId={assignmentId}>
              <ClientGalleryContextProvider assignmentId={assignmentId}>

                <ClientPropertyDocumentsGallery />

              </ClientGalleryContextProvider>
            </ThreadContextProvider>
          </GalleryProductContextProvider>
        </GalleryVisualTypeContextProvider>
      </GalleryDealContextProvider>
    </GalleryAssignmentContextProvider>
  )
}
